<template>
  <span
    v-if="cashbackValue"
    :class="`cashback-badge--${type}`"
    class="cashback-badge">
    <span
      :key="cashbackWithCurrency"
      class="cashback-badge__value">
      {{ cashbackWithCurrency }}
    </span>

    <span
      v-if="$slots.default"
      class="cashback-badge__text">
      <slot />
    </span>
  </span>
</template>

<script>
import { formatCurrencyString } from 'Root/helpers/tools';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'CashbackBadge',

  props: {
    type: {
      type: String,
      default: 'account',
      validator: (value) => ['account', 'product', 'product-gold', 'product-account'].includes(value),
    },

    price: {
      type: Number,
      default: null,
    },
  },

  computed: {
    ...mapState(['activeRegion']),
    ...mapGetters(['userCashback']),

    cashbackValue() {
      if (!this.userCashback) {
        return null;
      }

      if (this.type === 'product' && this.price) {
        return this.userCashback.rate * this.price;
      }

      if ((this.type === 'product-gold' || this.type === 'product-account') && this.price) {
        return (this.userCashback.rate * this.price) / 5;
      }

      if (this.type === 'account' && this.activeRegion) {
        return this.userCashback[`value_${this.activeRegion.shortTitle.toLowerCase()}`];
      }

      return null;
    },

    cashbackWithCurrency() {
      return formatCurrencyString(this.cashbackValue, this.activeRegion.id);
    },
  },
};
</script>

<style lang="scss" scoped>
  .cashback-badge {
    //--badge-font-size: 11px;
    //--badge-color: #{$color--basic-white};
    //--badge-background-color: #{$color--basic-green};
    //--badge-font-weight: 500;
    //--badge-padding: 0.5em;

    font-size: var(--badge-font-size, 11px);
    font-weight: var(--badge-font-weight, 500);
    color: var(--badge-color, #{$color--basic-white});
  }

  .cashback-badge__value {
    display: inline-block;
    background-color: var(--badge-background-color, #{$color--basic-blue});
    letter-spacing: 0.05em;
    padding: var(--badge-padding, 0.5em);
    white-space: nowrap;
    border-radius: 4px;
  }

  .cashback-badge__text {
    margin-left: 4px;
  }

  .cashback-badge--product {
    --background-color: #{$color--basic-blue};
  }
</style>
